var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.cof.js
 ** module id = 397
 ** module chunks = 1
 **/